import { NavBar } from 'antd-mobile'
import { useLocation } from '@tanstack/react-router'
import { LeftOutline } from 'antd-mobile-icons'
// 定义组件属性接口
interface NavBarComponentProps {
  title?: string
  showBack?: boolean
  rightContent?: React.ReactNode
  onBack?: () => void
}

// 定义页面标题映射对象
const PAGE_TITLE_MAP: Record<string, string> = {
  '/courses': '课程中心',
  '/favorites': '我的收藏',
  '/order': '我的订单',
}

// 定义主页面路径数组
const MAIN_PAGES = ['/', '/courses', '/favorites', '/order']

export default function NavBarComponent({
  title,
  showBack,
  rightContent,
  onBack,
}: NavBarComponentProps) {
  const location = useLocation()
  const pathname = location.pathname

  // 获取页面标题
  const getPageTitle = (): string => {
    if (pathname.startsWith('/course/detail')) return '课程详情'
    if (pathname.startsWith('/enroll/inputting')) return '填写信息'
    if (pathname.startsWith('/order/')) return '订单详情'
    if (title) return title
    return PAGE_TITLE_MAP[pathname] || '默认标题'
  }

  // 判断是否显示返回按钮
  const shouldShowBack = (): boolean => {
    if (showBack !== undefined) return showBack
    return !MAIN_PAGES.includes(pathname)
  }

  // 处理返回操作
  const handleBack = (): void => {
    if (onBack) onBack()
    else window.history.back()
  }

  // 根据页面标题设置样式
  const getStyleClass = (): string => {
    return getPageTitle() === '课程中心'
      ? 'bg-[transparent]'
      : 'bg-white border-[1px] border-[#F2F3F5] border-t-0 sticky top-0'
  }

  return (
    <div
      className={`top-0 left-0 right-0 mx-[auto] z-40  w-[100%] ${getStyleClass()}`}
    >
      <NavBar
        backIcon={shouldShowBack() ? <LeftOutline data-testid="back-icon"/> : false}
        onBack={shouldShowBack() ? handleBack : undefined}
        right={rightContent}
        style={{
          '--height': '48px',
          '--border-bottom': 'none',
        }}
      >
        <div className="text-lg font-medium text-[#333333]">
          {getPageTitle()}
        </div>
      </NavBar>
    </div>
  )
}
